import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { handlePaginatedParameters } from "../_helpers/handle-parameters";
import { optionsWithDefaultsPaginated } from "../_helpers/options-with-defaults";
import { PaginatedOptions, UseQueryOptionsNoKeyAndFn } from "../_types";
import {
  VEHICLE_VALUATION_COST_WARRANTY_RESOURCE,
  VEHICLE_VALUATION_COST_WARRANTY_SEARCH_API_PATH,
  VEHICLE_VALUATION_COST_WARRANTY_SEARCH_OPERATION,
  type VehicleValuationCostWarrantySearchBody,
  type VehicleValuationCostWarrantySearchParameters,
  type VehicleValuationCostWarrantySearchResponse,
} from "./vehicle-valuation-cost-warranty.types";

export function useVehicleValuationCostWarrantySearchQuery({
  options,
  enabled,
  queryOptions,
}: {
  options?: PaginatedOptions<VehicleValuationCostWarrantySearchParameters, VehicleValuationCostWarrantySearchBody>;
  enabled?: boolean;
  queryOptions?: UseQueryOptionsNoKeyAndFn<
    VehicleValuationCostWarrantySearchResponse,
    Error,
    VehicleValuationCostWarrantySearchResponse,
    readonly unknown[]
  >;
} = {}) {
  const optionsWithDefaults =
    optionsWithDefaultsPaginated<
      PaginatedOptions<VehicleValuationCostWarrantySearchParameters, VehicleValuationCostWarrantySearchBody>
    >(options);
  const params = handlePaginatedParameters(optionsWithDefaults.parameters);
  const body = optionsWithDefaults.body;

  return useQuery({
    queryKey: [
      VEHICLE_VALUATION_COST_WARRANTY_RESOURCE,
      VEHICLE_VALUATION_COST_WARRANTY_SEARCH_OPERATION,
      { params, body },
    ],
    queryFn: async () => {
      const response = await alphartisApiAxios.post<VehicleValuationCostWarrantySearchResponse>(
        VEHICLE_VALUATION_COST_WARRANTY_SEARCH_API_PATH,
        body,
        {
          params,
        },
      );

      return response.data;
    },
    ...queryOptions,
    enabled,
  });
}
